// import '../utils/effects.js'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import './assets/scss/styles.css'
import 'compass-mixins'
import {Route, BrowserRouter, Redirect, Switch} from 'react-router-dom'
import {userListener} from '../actions/userActions'
import Login from './Login'
import Register from './Register'
import Recover from './Recover'
import Dashboard from './Dashboard'
import Header from './Header'
import Home from './Home';
import Bg from './Bg';
import Notfound from './Notfound';
import Raven from 'raven-js';
import Hackathon from './Hackathon';
import Terms from './Terms';
import Donate from './Donate';
Raven.config('https://9048eccf9b0a4f5eac2437d40be1a26e@sentry.io/1201701').install();

function PrivateRoute({
  component: Component,
  authed,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === true
      ? <Component {...props}/>
      : <Redirect
        to={{
        pathname: "/login",
        state: {
          from: props.location
        }
      }}/>}/>
  )
}

@connect((store) => {
  return {
    userData: store.user.userData, 
    auth: store.user.auth,
    loginProgress: store.user.loginProgress,
    selectedCompany: store.user.selectedCompany, 
    userCompanies: store.user.userCompanies}
})
class App extends Component {

  componentWillMount() {
    this.props.dispatch(userListener())
  }
  
  render() {

    return (
      <BrowserRouter>
        <div className="container">
          <Bg/>
          <Header/>
          <Switch>
            <Route path='/' exact component={Home}/>
            <Route path='/login' exact component={Login}/>
            <Route path='/register' exact component={Register}/>
            <Route path='/recover' exact component={Recover}/>
            <Route path='/hackathon' exact component={Hackathon}/>
            <Route path='/terms' exact component={Terms}/>
            <Route path='/donate' exact component={Donate}/>
            <PrivateRoute authed={this.props.auth} path='/dashboard' component={Dashboard}/>
            <Route component={Notfound}/>
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js